/*
 * 督查模块接口
 */

import { post, get, postFormData, put, del } from 'api/http'
import storage from 'src/unit/storage'

export default {

    // 督查列表
    getExamineList(data) {
        // return post('/supervision/query', data)
        return get('/app/supervision/contract', data)
    },

    // 督查详情列表
    getExamineDetail(data) {
        // return post('/supervision/detail', data)
        return get('/app/supervision', data)
    },

    // 督查子项详情
    getExamineItemDetail(data) {
        // return get('/supervision/mdetail', data)
        return get('/app/supervision', data)
    },

    // 设置信号状态
    setExamineSignal(data) {
        // return post('/supervision/warning_signal', data)
        return put('/app/contract/signal', data)
    },

    // 添加督查
    addExamine(data) {
        // return post('/supervision/create', data)
        return post('/app/supervision', data)
    },

    // 删除督查
    deleteExamine(data) {
        // return post('/supervision/delete', data)
        return del('/app/supervision', data)
    },

    // 添加督查前,获取督查人名称
    getExaminerName(data) {
        return get('/supervision/create', data)
    },

    // 更新督查
    updateExamine(data) {
        // return post('/supervision/mdetail', data)
        return put('/app/supervision', data)
    },

    // 更新督查评分
    examineScore(data) {
        // return post('/supervision/score', data)
        return put('/app/supervision/score', data)
    },

    // 获取督查评分详情
    getMaintenanceQuality(data) {
        // return get('/app/supervision/score', data)
        return get('/app/supervision/score', data)
    },

    // 问题列表
    problemList(data) {
        // return post('/supervision/problem/query', data)
        return get('/app/problem', data)
    },

    // 问题详情
    problemDetail(data) {
        // return get('/supervision/problem/detail', data)
        return get('/app/problem', data)
    },

    // 问题创建
    problemCreate(data) {
        // return post('/supervision/problem/create', data)
        return post('/app/problem', data)
    },

    // 问题更新
    problemUpdate(data) {
        // return post('/supervision/problem/detail', data)
        return put('/app/problem', data)
    },

    // 问题删除
    problemDelete(data) {
        // return post('/supervision/problem/delete', data)
        return del('/app/problem', data)
    },

    // 问题整改、验收
    problemOperation(data) {
        // return post('/supervision/problem/operation', data)
        return post('/app/problem/operation', data)
    },

    // 问题验收
    postProblemOperation(data) {
        // return post('/supervision/problem/operation', data)
        return post('/app/problem/operation/commit', data)
    },

    // 验收记录
    rectificationList(data) {
        return get('/app/problem/rectification', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/examine.js